<template>
  <v-simple-table style="width: 97%; margin-top: 16px" fixed-header height="300px" id="style-2">
    <template v-slot:default>
      <thead>
        <tr>
          <th style="background: #1289F8; color: white; min-width: 350px; max-width: 350px; position: sticky; left: 0; z-index: 3">
            <div class="d-flex align-center justify-start w-100">
              <transition-group tag="div" class="div-slider w-100" :name="back? 'slideback' : 'slide'">
                <div v-if="level === 0" key="level-1" class="w-100 text-left card" style="position: absolute">Môn - Khối lớp</div>
                <div v-else-if="level === 1" key="level-2" class="d-flex align-center w-100 card">
                  <div v-if="level > 0" @click="handleGoBack" class="mr-2" style="cursor: pointer">
                    <v-icon color="white">mdi-arrow-left</v-icon>
                  </div>
                  Khóa học
                </div>
                <div v-else key="level-3" class="d-flex align-center w-100 card">
                  <div v-if="level > 0" @click="handleGoBack" class="mr-2" style="cursor: pointer">
                    <v-icon color="white">mdi-arrow-left</v-icon>
                  </div>
                  <div style="width: 350px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; text-align: left">{{categoryName}}</div>
                </div>
              </transition-group>
<!--              <transition name="fade" mode="out-in">-->
<!--                <div v-if="level === 0" key="level-1">Môn - Khối lớp</div>-->
<!--                <div v-else-if="level === 1" key="level-2" class="d-flex align-center">-->
<!--                  <div v-if="level > 0" @click="level -=1" class="mr-2" style="cursor: pointer">-->
<!--                    <v-icon color="white">mdi-arrow-left</v-icon>-->
<!--                  </div>-->
<!--                  Khóa học</div>-->
<!--                <div v-else key="level-3" class="d-flex align-center">-->
<!--                  <div v-if="level > 0" @click="level -=1" class="mr-2" style="cursor: pointer">-->
<!--                    <v-icon color="white">mdi-arrow-left</v-icon>-->
<!--                  </div>-->
<!--                  {{categoryName}}</div>-->
<!--              </transition>-->
            </div>
          </th>
          <th v-for="column in columnData"
              :key="column"
              class="bg-blue white--text"
              style="background: #1289F8; min-width: 150px; max-width: 150px">
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody v-if="computedDataTable && computedDataTable.length > 0">
        <tr
          v-for="(subject, index) in computedDataTable"
          :key="'tr'+index"
        >
          <td class="text-left" style="position: sticky; left: 0">
            <div :style="isViewable ? 'color: #1289F8; cursor: pointer': 'color: black'" @click="isViewable  ? handleViewDetail(subject) : ''">
              <strong>{{level === 0 ? subject.subjectGradeName : level === 1 ? subject.courseName : subject.categoryName}}</strong>
            </div>
          </td>
          <td>
            {{subject.doneSection}}/{{subject.totalSection}} bài
            <br>
            {{subject.sectionRate}}
          </td>
          <td>{{subject.totalQuestion}}</td>
          <td>{{subject.correctQuestion}}</td>
          <td>{{subject.wrongQuestion}}</td>
          <td>{{subject.avgPoint}}</td>
  <!--        <td><strong>{{ subject.subjectName }}</strong></td>-->
  <!--        <td>-->
  <!--          <div v-if="subject.correctQuestion !== null && subject.totalQuestion !== null">-->
  <!--            <span style="color: #0180C7; font-size: 16px; margin-right: 4px">{{ subject.correctQuestion }}</span>/<span>{{ subject.totalQuestion }}</span>-->
  <!--          </div>-->
  <!--        </td>-->
  <!--        <td>-->
  <!--          <div class="text-no-wrap">-->
  <!--            <span>{{ subject.diemTb !== null ? subject.diemTb.toFixed(1) : '' }}</span>-->
  <!--            <span v-if="subject.compare != 'equal'" class="ml-3">-->
  <!--                <v-icon small color="green" v-if="subject.compare === 'increase'">mdi-arrow-up</v-icon>-->
  <!--                <v-icon small color="red" v-else>mdi-arrow-down</v-icon>-->
  <!--                <v-tooltip-->
  <!--                  top-->
  <!--                  color="transparent"-->
  <!--                >-->
  <!--                  <template-->
  <!--                    v-slot:activator="{ on, attrs}"-->
  <!--                  >-->
  <!--                    <span-->
  <!--                      v-on="on"-->
  <!--                      v-bind="attrs"-->
  <!--                    >-->
  <!--                      {{ parseFloat(subject.comparePoint).toFixed(1) }}-->
  <!--                    </span>-->
  <!--                  </template>-->
  <!--                  <span class="compare-tooltip">{{subject.compare === 'increase' ? 'Tăng ' : 'Giảm '}} {{parseFloat(subject.comparePoint).toFixed(1)}} điểm so với tháng trước</span>-->
  <!--                </v-tooltip>-->
  <!--            </span>-->
  <!--          </div>-->
  <!--        </td>-->
  <!--        <td v-if="columnData.length === 3">-->
  <!--          <div>-->
  <!--            <span>{{ subject.totalCategories }}</span>-->
  <!--          </div>-->
  <!--        </td>-->
          <!-- <template v-for="subject in dataTable">
            <td :key="subject.subjectName">
              <div v-if="column === 'Số câu đúng/tổng số câu'">
                <div v-if="subject.correctQuestion !== null && subject.totalQuestion !== null">
                  <span style="color: #0180C7; font-size: 16px; margin-right: 4px">{{ subject.correctQuestion }}</span>/<span>{{ subject.totalQuestion }}</span>
                </div>
              </div>
              <div v-if="column === 'Điểm TB'">
                <span>{{ subject.diemTb !== null ? subject.diemTb.toFixed(1) : '' }}</span>
                <span v-if="subject.compare != 'equal'" class="ml-3">
                    <v-icon small color="green" v-if="subject.compare === 'increase'">mdi-arrow-up</v-icon>
                    <v-icon small color="red" v-else>mdi-arrow-down</v-icon>
                    <v-tooltip
                      top
                      color="transparent"
                    >
                      <template
                        v-slot:activator="{ on, attrs}"
                      >
                        <span
                          v-on="on"
                          v-bind="attrs"
                        >
                          {{ parseFloat(subject.comparePoint).toFixed(1) }}
                        </span>
                      </template>
                      <span class="compare-tooltip">{{subject.compare === 'increase' ? 'Tăng ' : 'Giảm '}} {{parseFloat(subject.comparePoint).toFixed(1)}} điểm so với tháng trước</span>
                    </v-tooltip>
                </span>
              </div>
              <div v-if="column === 'Chủ đề đã học'">
                <span>{{ subject.totalCategories }}</span>
              </div>
            </td>
          </template> -->
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="6">
            <div class="d-flex flex-column">
              <div class="d-flex align-center justify-center mt-3">
                <img src="../../assets/emty-data-homework.svg" style="width: 400px" alt="">
              </div>
              <span style="font-size: 16px; font-weight: bold; margin-top: 10px">Thời gian lựa chọn không có thông tin điểm học sinh</span>
              <span style="font-size: 12px; margin-top: 6px; margin-bottom: 10px">Bạn chọn khoảng thời gian khác để xem thông tin điểm học tập</span>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { TIENG_ANH } from '../../../../helpers/constant';

export default {
  name: 'SelfStudyViewDetailBySubject',
  props: {
    dataTable: {
      type: Array,
      default: () => [],
    },
    subjectId: {
      type: Number,
      default: 0,
    },
  },
  created() {
  },
  data() {
    return {
      back: false,
      level: 0,
      dataTableByCourse: [],
      dataTableByCategory: [],
      categoryName: '',
      columnData: ['Bài hoàn thành', 'Tổng số câu', 'Số câu đúng', 'Số câu sai', 'Điểm trung bình'],
      TIENG_ANH,
    };
  },
  computed: {
    isViewable() {
      if (this.subjectId === TIENG_ANH) {
        return this.level < 1;
      } return this.level < 2;
    },
    computedDataTable() {
      switch (this.level) {
        case 0:
          return this.dataTable;
        case 1:
          return this.dataTableByCourse;
        case 2:
          return this.dataTableByCategory;
        default:
          return this.dataTable;
      }
    },
  },
  methods: {
    handleGoBack() {
      this.back = true;
      this.level -= 1;
    },
    handleViewDetail(subject) {
      this.back = false;
      if (this.level === 0) {
        this.dataTableByCourse = subject.byCourse;
        this.level += 1;
      } else if (this.level === 1) {
        this.dataTableByCategory = subject.byCategory;
        this.categoryName = subject.courseName;
        this.level += 1;
      }
    },
  },
  watch: {
    // dataTable: {
    //   handler(val) {
    //     if (val.length === 1 && val[0].subjectId === TIENG_ANH) {
    //       this.columnData = ['Số câu đúng/tổng số câu', 'Điểm TB'];
    //     } else {
    //       this.columnData = ['Số câu đúng/tổng số câu', 'Điểm TB', 'Chủ đề đã học'];
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>

<style lang="scss" scoped>
thead tr th, tbody tr td {
  // border: 1px solid #0180c7;
  text-align: center !important;
  font-size: 14px !important;
}
tbody {
  &:hover {
    td {
      background-color: #f5f5f5;
    }
  }
  td {
    background-color: #F9F4F4;
    border-bottom: 2px solid #fff !important;
  }
}
.bg-blue {
  background: #52acff;
}
.compare-tooltip {
  color: black; border: 1px solid #D2D2D2;
  padding: 3px 6px;
  border-radius: 8px;
  background-color: white
}
.div-slider{
  overflow: hidden;
  position: relative;
  height: 20px;
}
.div-slider .card{
  height: 20px;
  position: absolute;
}
</style>
